import { memo, type ReactNode } from 'react';


export default memo(function ObjectSuspense(props: { fallback: ReactNode, track: unknown, children: ReactNode }) {
    return (<>
        {props.track ? props.children : props.fallback}
    </>);
})